import { render, staticRenderFns } from "./CandidateCard.vue?vue&type=template&id=8111e974&scoped=true"
import script from "./CandidateCard.vue?vue&type=script&lang=ts"
export * from "./CandidateCard.vue?vue&type=script&lang=ts"
import style0 from "./CandidateCard.vue?vue&type=style&index=0&id=8111e974&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8111e974",
  null
  
)

export default component.exports